"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 24 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var CompetitorPriceRawDataConverter_1 = require("./conversions/CompetitorPriceRawDataConverter");

var CompetitorPriceRawDataConverterImpl_1 = require("./conversions/CompetitorPriceRawDataConverterImpl");

var DataUploadConverter_1 = require("./conversions/DataUploadConverter");

var DataUploadConverterImpl_1 = require("./conversions/DataUploadConverterImpl");
/**
 * Configures data upload app module.
 *
 * @author Jaroslav Sevcik
 */


var DataUploadAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(DataUploadAppModule, _AppModule_1$AppModul);

  function DataUploadAppModule() {
    var _this;

    _classCallCheck(this, DataUploadAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataUploadAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'dataUploadAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DataUploadAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CompetitorPriceRawDataConverter_1.CompetitorPriceRawDataConverter).to(CompetitorPriceRawDataConverterImpl_1.CompetitorPriceRawDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataUploadConverter_1.DataUploadConverter).to(DataUploadConverterImpl_1.DataUploadConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return DataUploadAppModule;
}(AppModule_1.AppModule);

exports.DataUploadAppModule = DataUploadAppModule;